document.addEventListener('DOMContentLoaded', () => {
  // Colour/size swatches built by the theme itself (replaces the Globo swatch app).
  // Uses the hidden variant list on the page plus #hoh-swatch-data (option names and one small photo per variant).
  const swatchData = document.getElementById('hoh-swatch-data');
  if (swatchData) {
    let swatchInfo = null;
    try { swatchInfo = JSON.parse(swatchData.textContent); } catch { swatchInfo = null; }
    document.querySelectorAll('[data-product-section]').forEach((section, sectionIndex) => {
      const holder = section.querySelector('.os-glo-swatches');
      const variantList = section.querySelector('[data-variant-select]');
      if (!swatchInfo || !holder || !variantList || section.querySelector('[data-option-group]')) return;
      const variants = [...variantList.options].map((option, index) => {
        let values = [];
        try { values = JSON.parse(option.dataset.options || '[]'); } catch { values = []; }
        return { values, image: (swatchInfo.images || [])[index] || null, selected: option.selected };
      });
      if (variants.length < 2) return;
      const current = variants.find((variant) => variant.selected) || variants[0];
      const pickers = document.createElement('div');
      pickers.className = 'os-option-pickers';
      (swatchInfo.options || []).forEach((name, index) => {
        const values = [...new Set(variants.map((variant) => variant.values[index]).filter((value) => value !== undefined))];
        if (!values.length) return;
        const visual = /colou?r|kleur|kolor/i.test(name);
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'os-option-picker' + (visual ? ' os-option-picker--visual' : '');
        fieldset.setAttribute('data-option-group', '');
        fieldset.dataset.optionIndex = String(index);
        const legend = document.createElement('legend');
        const selectedLabel = document.createElement('strong');
        selectedLabel.setAttribute('data-selected-option', '');
        selectedLabel.textContent = current.values[index] || '';
        legend.append(`${name}: `, selectedLabel);
        const valuesBox = document.createElement('div');
        valuesBox.className = 'os-option-picker__values';
        values.forEach((value, valueIndex) => {
          const id = `HohOption-${sectionIndex}-${index}-${valueIndex}`;
          const input = document.createElement('input');
          input.type = 'radio';
          input.className = 'visually-hidden';
          input.id = id;
          input.name = `hoh-option-${sectionIndex}-${index}`;
          input.value = value;
          input.checked = value === current.values[index];
          const label = document.createElement('label');
          label.htmlFor = id;
          label.title = value;
          if (visual) {
            const swatch = document.createElement('span');
            swatch.className = 'os-color-swatch';
            const withPhoto = variants.find((variant) => variant.values[index] === value && variant.image);
            if (withPhoto) {
              swatch.style.backgroundImage = `url("${withPhoto.image}")`;
              swatch.style.backgroundSize = 'cover';
              swatch.style.backgroundPosition = 'center';
            } else {
              const cssColour = String(value).toLowerCase().replace(/\s+/g, '');
              swatch.style.setProperty('--swatch-color', window.CSS && CSS.supports('color', cssColour) ? cssColour : '#D8D4CC');
            }
            const hiddenName = document.createElement('span');
            hiddenName.className = 'visually-hidden';
            hiddenName.textContent = value;
            label.append(swatch, hiddenName);
          } else {
            const text = document.createElement('span');
            text.textContent = value;
            label.append(text);
          }
          valuesBox.append(input, label);
        });
        fieldset.append(legend, valuesBox);
        pickers.append(fieldset);
      });
      holder.replaceChildren(pickers);
    });
  }

  const managedVideos = [...document.querySelectorAll('video[autoplay]')];
  const loadVideo = (video) => {
    if (video.dataset.loaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.loaded = 'true';
    video.load();
  };

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadVideo(video);
          if (video.autoplay) video.play().catch(() => {});
        } else if (video.autoplay && video.dataset.loaded === 'true') {
          video.pause();
        }
      });
    }, { threshold: 0.15 });
    managedVideos.forEach((video) => videoObserver.observe(video));
  } else {
    managedVideos.forEach((video) => {
      loadVideo(video);
      if (video.autoplay) video.play().catch(() => {});
    });
  }

  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-carousel-track]');
    const slides = [...gallery.querySelectorAll('.os-product__slide')];
    const dots = [...gallery.querySelectorAll('[data-carousel-dot]')];
    if (!track || slides.length < 2) return;

    const setActiveSlide = (index, scroll = false) => {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === safeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (scroll) track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => setActiveSlide(Number(dot.dataset.carouselDot), true));
    });

    let frame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActiveSlide(index);
      });
    }, { passive: true });

    gallery.showMedia = (mediaId) => {
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0) setActiveSlide(index, true);
    };
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('.os-product-form');
    const variantSelect = section.querySelector('[data-variant-select]');
    const groups = [...section.querySelectorAll('[data-option-group]')];
    const formVariantInputs = [...section.querySelectorAll('[data-product-form-variant]')];
    if (!form || !variantSelect) return;

    const updateVariant = (variantOption) => {
      if (!variantOption) return;
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const saving = section.querySelector('[data-product-saving]');
      const stock = section.querySelector('[data-product-stock]');
      const button = section.querySelector('[data-add-to-cart]');
      const gallery = section.querySelector('[data-product-gallery]');
      const available = variantOption.dataset.available === 'true';

      variantSelect.value = variantOption.value;
      formVariantInputs.forEach((input) => { input.value = variantOption.value; });
      if (price) price.textContent = variantOption.dataset.price || '';
      if (compare) {
        compare.textContent = variantOption.dataset.comparePrice || '';
        compare.hidden = !variantOption.dataset.comparePrice;
      }
      if (saving) {
        saving.textContent = variantOption.dataset.saving || '';
        saving.hidden = !variantOption.dataset.saving;
      }
      if (stock) {
        stock.textContent = available ? stock.dataset.availableText : stock.dataset.unavailableText;
        stock.classList.toggle('is-unavailable', !available);
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }
      if (variantOption.dataset.mediaId && gallery?.showMedia) gallery.showMedia(variantOption.dataset.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantOption.value);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group) => {
      group.addEventListener('change', () => {
        const selected = group.querySelector('input:checked');
        const label = group.querySelector('[data-selected-option]');
        if (label && selected) label.textContent = selected.value;

        const selectedValues = groups.map((item) => item.querySelector('input:checked')?.value);
        const match = [...variantSelect.options].find((option) => {
          try {
            return JSON.parse(option.dataset.options || '[]').every((value, index) => value === selectedValues[index]);
          } catch {
            return false;
          }
        });
        updateVariant(match);
      });
    });

    section.addEventListener('change', (event) => {
      const variantField = event.target.closest('[name="id"]');
      if (!variantField) return;
      const match = [...variantSelect.options].find((option) => option.value === String(variantField.value));
      if (match) updateVariant(match);
    });
  });
});
